import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";

const HeaderBack = () => {
  const history = useHistory();

  const backClicked = () => {
    const userType = Cookies.get("userType");

    // מלווה בלבד
    if (userType === "2") {
      history.push("/helperHome");
      return;
    }

    // אם יש היסטוריה → חזור אחורה
    if (history.length > 1) {
      history.goBack();
      return;
    }

    // ברירת מחדל
    history.push("/questionnaires");
  };

  return (
    <div className="headerback">
      <div className="backhome" onClick={backClicked} />
    </div>
  );
};

export default HeaderBack;
